import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CustomAvatar from './../Avatar/Avatar';
import CustomButton from './../Forms/CustomButton/CustomButton';
import FontIcon from './../FontIcon/FontIcon';
import Modal from './../../common/Modal/Modal';
// scss
import { ChangePassword } from "./ChangePassword";
import './Header.scss';

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			
			modalOpen: false,
			collapsed: true,
			anchorEl: null,
			open: false
		};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleRequestClose = this.handleRequestClose.bind(this);
	}

	toggleMenu() {
		this.setState({
			collapsed: !this.state.collapsed,
		});
	}

	handleClick = (event) => {
		this.setState({ open: true });
		this.setState({ anchorEl: event.currentTarget });
	};

	handleRequestClose = () => {
		this.setState({ open: false });
	};

	logOut() {
		this.props.loginContext.updateAuth(false);
		window.location.reload();
	}
	
	render() {

		const { match } = this.props;

		return (
			<AppBar className="Header" position="fixed" color="default">
        		<Toolbar className="toolbar">
        			<div className="brand-menu">
        				<CustomButton
        					iconOnly
        					iconName='menu'
        					size='medium'
							color='rgba(255, 255, 255, 0.6)'
        					onClick={() => this.toggleMenu()}
        				/>
						<NavLink to={match.url} className="brand">
							<div className="header-logo">
								<img src="./assets/images/svg/logo_white.svg" alt="leanwisdom_logo" />
							</div>
						</NavLink>
					</div>
					<div className={`menus ${!this.state.collapsed ? 'show' : ''}`}>
						{ this.props.loginContext.loginDetails.type === 'P' &&
						<React.Fragment>
							<div className="menu-item">
								<NavLink onClick={() => this.toggleMenu()} to={`${match.url}dashboard`} replace>
									<FontIcon iconName='dashboard' />
									<div className="dashboard-item">Dashboard</div>						
								</NavLink>
							</div>
						</React.Fragment>
						}
						{ this.props.loginContext.loginDetails.type !== 'P' &&
							<React.Fragment>
								<div className="menu-item">
									<NavLink onClick={() => this.toggleMenu()} to={`${match.url}course`} replace>
										<FontIcon iconName='course' />
										<div className="dashboard-item">Courses</div>						
									</NavLink>
								</div>
								<div className="menu-item">
									<NavLink onClick={() => this.toggleMenu()} to={`${match.url}batch`} replace>
										<FontIcon iconName='batch' />
										<div className="dashboard-item">Batches</div>						
									</NavLink>
								</div>
								<div className="menu-item">
									<NavLink onClick={() => this.toggleMenu()} to={`${match.url}user`} exact replace>
										<FontIcon iconName='user' />
										<div className="dashboard-item">User</div>						
									</NavLink>
								</div>
								<div className="menu-item">
									<NavLink onClick={() => this.toggleMenu()} to={`${match.url}trainer`} exact replace>
										<FontIcon iconName='user' />
										<div className="dashboard-item">Trainer</div>						
									</NavLink>
								</div>
								<div className="menu-item">
									<NavLink onClick={() => this.toggleMenu()} to={`${match.url}salesexecutive`} exact replace>
										<FontIcon iconName='user' />
										<div className="dashboard-item">Sales Executive</div>						
									</NavLink>
								</div>
							</React.Fragment>							
						}						
					</div>
					{ this.props.loginContext &&
						<div className='userinfo' onClick={this.handleClick}>
							<CustomAvatar size={35} name={`${this.props.loginContext.loginDetails.firstname} ${this.props.loginContext.loginDetails.lastname}`} />
							<p>{this.props.loginContext.loginDetails.firstname} {this.props.loginContext.loginDetails.lastname}</p>
							<FontIcon
								iconName='arrow'
								color='rgba(255, 255, 255, 0.6)'
							/>
						</div>
					}
					<Menu
						className='view-info'
						id='simple-menu'
						anchorEl={this.state.anchorEl}
						anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
						open={this.state.open}
						onClose={this.handleRequestClose}
						PaperProps={{
							style: {
								paddingTop: 0,
								paddingBottom: 0
							}
						}}
					>
						

						<MenuItem onClick={() => {
							this.logOut();
							this.handleRequestClose();
						}}>
							<FontIcon iconName='logout' />
							Logout
						</MenuItem>
					</Menu>
				</Toolbar>
      		</AppBar>
		);
	}
}

Header.propTypes = {
	match: PropTypes.instanceOf(Object),
	history: PropTypes.instanceOf(Object)
};

Header.defaultProps = {
	match: {},
	history: {}
};

export default Header;


// WEBPACK FOOTER //
// ./common/Header/Header.js